import { tokens } from '@equinor/eds-tokens';
import { primary as primary$1, secondary as secondary$1, danger as danger$1 } from './contained.js';
import mergeDeepRight from '../../../node_modules/.pnpm/ramda@0.29.0/node_modules/ramda/es/mergeDeepRight.js';

var _tokens$clickbounds = tokens.clickbounds,
  clicboundHeight = _tokens$clickbounds.default__base,
  compactClickboundHeight = _tokens$clickbounds.compact__standard,
  shape = tokens.shape;
var contained_icon = {
  height: shape.icon_button.minHeight,
  width: shape.icon_button.minWidth,
  border: {
    width: '0px',
    radius: '50%'
  },
  spacings: {
    left: '0',
    right: '0'
  },
  clickbound: {
    width: clicboundHeight,
    offset: {
      top: '0',
      left: "".concat((parseInt(clicboundHeight) - parseInt('40px')) / 2, "px")
    }
  },
  states: {
    hover: {
      border: {
        width: '0px',
        radius: '50%'
      }
    }
  },
  modes: {
    compact: {
      height: shape._modes.compact.icon_button.minHeight,
      width: shape._modes.compact.icon_button.minWidth,
      clickbound: {
        width: compactClickboundHeight,
        offset: {
          top: '0',
          left: "".concat((parseInt(compactClickboundHeight) - parseInt(shape._modes.compact.icon_button.minWidth)) / 2, "px")
        }
      }
    }
  }
};
var primary = mergeDeepRight(primary$1, contained_icon);
var secondary = mergeDeepRight(secondary$1, contained_icon);
var danger = mergeDeepRight(danger$1, contained_icon);

export { danger, primary, secondary };
